<template>
  <div class="org-users shared-index">
    <h3 class="m-0">Thông tin trang banner</h3>
    <div class="table">
      <p>
        <span>Tên trang: </span>
        <b class="text-primary">{{ page.label }}</b>
      </p>
      <p>
        <span>Mô tả: </span>
        <b class="text-primary">{{ page.description }}</b>
      </p>
      <p>
        <span>Link truy cập: </span>
        <a class="text-primary" :href="page.link" target="_blank">{{ page.link }}</a>
      </p>
    </div>
  </div>
</template>

<script>

export default {
  name: 'OrgInfomation',
  props: {
    page: Object
  },
  computed: {}
}
</script>

<style lang="scss" scoped>
</style>
